import { useProduct } from "@/components/pdp/PdpDataContext";

export const MarqueeBand = () => {
  const { marquee } = useProduct();
  const row = [...marquee, ...marquee];
  return (
    <section className="bg-riversol-blue text-white py-6 overflow-hidden border-y border-white/10" data-testid="marquee-band" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {row.map((t, i) => (
          <span key={i} className="font-mono text-sm tracking-[0.15em] uppercase mx-8 inline-flex items-center gap-8">
            {t}
            <span className="text-white/30">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};

export default MarqueeBand;
